import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})

export default class GrossingTouchVoiceRecorderCard extends Vue {
    @Prop({ default: false }) readonly active!: boolean
}
